import { Field } from 'formik'
import React from 'react'

import { Checkbox, Fieldset, Subsection } from '@fourthwall/components'

import type { FormValues } from '../../EmailNotifications.types'

export const MarketingEmails = () => {
  return (
    <Subsection title="Marketing emails">
      <Fieldset>
        <Fieldset.Row>
          <Fieldset.Item>
            <Field
              component={Checkbox}
              name={'creatorDigest' satisfies FormValues}
              label="Creator Digest"
              description="Our monthly newsletter with the latest updates, tips, and creator spotlights"
            />
          </Fieldset.Item>
        </Fieldset.Row>
        <Fieldset.Row>
          <Fieldset.Item>
            <Field
              component={Checkbox}
              name={'productUpdates' satisfies FormValues}
              label="Product updates"
              description="Learn about latest updates to the Fourthwall platform"
            />
          </Fieldset.Item>
        </Fieldset.Row>
        <Fieldset.Row>
          <Fieldset.Item>
            <Field
              component={Checkbox}
              name={'oneOffCampaigns' satisfies FormValues}
              label="One-off campaigns"
              description="Get notified about promotional offers and community updates"
            />
          </Fieldset.Item>
        </Fieldset.Row>
      </Fieldset>
    </Subsection>
  )
}
